class CookiesProvider {
  constructor(data) {
    this.data = data;
  }

  getState(currentState) {
    return { ...currentState };
  }
}

export default CookiesProvider;
